import { API_ORIGIN } from '../config';
const API_BASE = `${API_ORIGIN}/api/form-languages`;

const languageService = {
  // Get all available languages
  getAllLanguages: async () => {
    const response = await fetch(`${API_BASE}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to fetch languages');
    }

    return data;
  },

  // Get a specific language by ID
  getLanguage: async (languageId) => {
    const response = await fetch(`${API_BASE}/${languageId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to fetch language');
    }

    return data;
  },

  // Update language texts (admin only)
  updateLanguage: async (languageId, { application_text, submit_text }) => {
    const response = await fetch(`${API_BASE}/${languageId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ application_text, submit_text }),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to update language');
    }

    return data;
  },

  // Toggle form language between Maltese (1) and English (2)
  toggleFormLanguage: async (formId, languageId) => {
    const response = await fetch(`${API_BASE}/forms/${formId}/toggle`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ language_id: languageId }),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to toggle form language');
    }

    return data;
  },

  // Get form's current language settings
  getFormLanguage: async (formId) => {
    const response = await fetch(`${API_BASE}/forms/${formId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to fetch form language');
    }

    return data;
  },
};

export default languageService;
